import { Actor, Animation, Color, SpriteSheet, vec } from 'excalibur';
import { resources } from '../../../Resources';
import { tintAnimation } from '../../../shared/utilities/tintAnimation';

export class StaticHelicopter extends Actor {
    constructor(x: number, y: number, private _tintColor?: Color) {
        super({
            pos: vec(x, y),
            width: 60,
            height: 20,
        });
    }

    private spriteSheetRight = resources.games.helicopters.actors.helicopter.spritesheetHueyRight300x2881x3;
    private sheetRight!: SpriteSheet;
    private animRight!: Animation;

    private pilot!: Actor;
    private copilot!: Actor;
    private hull!: Actor;

    private readonly SEAT_PILOT = vec(55, 8);
    private readonly SEAT_COPILOT = vec(51, 7);

    private pilotSheet!: SpriteSheet;
    private pilotAnim!: Animation;
    private copilotSheet!: SpriteSheet;
    private copilotAnim!: Animation;

    override onInitialize(): void {
        this.sheetRight = SpriteSheet.fromImageSource({
            image: this.spriteSheetRight,
            grid: { rows: 3, columns: 1, spriteWidth: 300, spriteHeight: 96 },
        });
        this.animRight = Animation.fromSpriteSheet(this.sheetRight, [0, 1, 2], 25);
        this.pilotSheet = SpriteSheet.fromImageSource({
            image: resources.games.helicopters.actors.helicopter.spritesheetPilot32x642x1,
            grid: { rows: 1, columns: 2, spriteWidth: 32, spriteHeight: 32 },
        });
        this.pilotAnim = Animation.fromSpriteSheet(this.pilotSheet, [0, 1], 400);
        this.copilotSheet = SpriteSheet.fromImageSource({
            image: resources.games.helicopters.actors.helicopter.spritesheetPilot32x642x1,
            grid: { rows: 1, columns: 2, spriteWidth: 32, spriteHeight: 32 },
        });
        this.copilotAnim = Animation.fromSpriteSheet(this.copilotSheet, [0, 1], 350);
        // Create child actors (pilots) first = behind
        this.pilot = new Actor({ pos: this.SEAT_PILOT.clone(), anchor: vec(0.5, 0.5) });
        this.pilot.scale = vec(0.4, 0.4);
        this.pilot.graphics.use(this.pilotAnim);
        this.addChild(this.pilot);

        this.copilot = new Actor({ pos: this.SEAT_COPILOT.clone(), anchor: vec(0.5, 0.5) });
        this.copilot.scale = vec(0.4, 0.4);
        this.copilot.graphics.use(this.copilotAnim);
        this.addChild(this.copilot);

        this.hull = new Actor({ pos: vec(0, 0), anchor: vec(0.5, 0.5) });
        this.hull.graphics.use(this.animRight);
        this.addChild(this.hull);

        if (this._tintColor) tintAnimation(this.animRight, this._tintColor, 0.6);
    }
}
